module.exports = __webpack_public_path__ + "img/DE05661.04b9afdc.png";